import React, { forwardRef } from 'react';

const Stack = forwardRef(({ direction = 'horizontal', gap = 0, align, justify, children, className = '', style = {}, ...props }, ref) => {
  const computedClassName = `comp-stack ${direction} ${typeof gap === 'string' ? `gap-${gap}` : ''} ${align ? `align-${align}` : ''} ${justify ? `justify-${justify}` : ''} ${className}`.trim().replace(/\s+/g, ' ');
  const computedGapStyle = typeof gap === 'number' ? { gap: `${gap}px` } : {};

  return (
    <div ref={ref} className={computedClassName} style={{ ...computedGapStyle, ...style }} {...props}>
      {children}
    </div>
  );
});

Stack.displayName = 'Stack';

export default Stack;
